import { DateTime } from 'luxon';

type dateFormatterOptions = {
    withTime?: boolean,
    fromFormat?: string,
    toFormat?: string,
    toFormatWithoutTime?: string,
};

const monthNames: string[] = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];

function formatFromUTC(
    utc: string | Date,
    {
        withTime = true,
        fromFormat = undefined,
        toFormat = 'dd.LL.yyyy HH:mm:ss',
        toFormatWithoutTime = 'dd.LL.yyyy',
    }: dateFormatterOptions = {},
): string {
    const date = utc instanceof Date
        ? DateTime.fromJSDate(utc).toLocal()
        : (
            fromFormat === undefined
                ? DateTime.fromSQL(utc, { zone: 'UTC' }).toLocal()
                : DateTime.fromFormat(utc, fromFormat, { zone: 'UTC' }).toLocal()
        );

    return withTime ? date.toFormat(toFormat) : date.toFormat(toFormatWithoutTime);
}

function formatToUTC(
    local: string | Date,
    {
        withTime = true,
        fromFormat = undefined,
        toFormat = 'yyyy-LL-dd HH:mm:ss',
        toFormatWithoutTime = 'yyyy-LL-dd',
    }: dateFormatterOptions = {},
): string {
    const date = local instanceof Date
        ? DateTime.fromJSDate(local)
        : (
            fromFormat === undefined
                ? DateTime.fromSQL(local)
                : DateTime.fromFormat(local, fromFormat)
        );

    return withTime ? date.toUTC().toFormat(toFormat) : date.toFormat(toFormatWithoutTime);
}

function getMonthNameByNumber(monthNumber: number): string {
    return monthNames[monthNumber - 1];
}

export { monthNames, formatFromUTC, formatToUTC, getMonthNameByNumber };
